import { ConvexHttpClient } from "convex/browser";

import { api } from "../../../../convex/_generated/api";

export const setupStatusQuery = api.setup.status;

/**
 * Exercise the generated public API from the web package without importing a
 * backend implementation module. Callers supply the browser-safe local URL.
 */
export async function queryConvexSetup(convexUrl: string): Promise<{ ready: true }> {
  const client = new ConvexHttpClient(convexUrl);

  return client.query(setupStatusQuery, {});
}
